import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { useSelector } from "react-redux";
// import LinkedIn from "../../../Assets/Linkedin.png"
// import Youtube from "../../../Assets/youtube.png"


export default function Footer() {
    const smallScreen = useMediaQuery("(max-width:600px)");
    const functionSlice = useSelector(state => state.functionslice.value);

    return (
        <footer className="footer-container">

            {/* ======= MOBILE VERSION ======= */}
            {smallScreen ? (
                <>
                    {/* Logo */}
                    <div className="footer-logo-center">
                        <img src="/Images/Icons/logo-green.svg" alt="PARIMITRA" className="footer-logo-img" />
                    </div>

                    {/* Tagline */}
                    <p className="brand-tagline tagline-center">
                        Redefining Indian Roads with<br /> Smart Mobility Solutions.
                    </p>

                    {/* 2 Columns: Solutions + Company */}
                    <div className="footer-columns-mobile">
                        <div className="footer-col">
                            <h3>Solutions</h3>
                            <Link to="/products/trafficeye">Traffic Eye</Link>
                            <Link to="/products/transiteye">Transit Eye</Link>
                            <Link to="/products/crowdeye">Crowd Eye</Link>
                            <Link to="/products/video-analytics">Video Analytics</Link>
                        </div>

                        <div className="footer-col">
                            <h3>Company</h3>
                            <Link to="/about">About Us</Link>
                            <Link to="/gallery">Gallery</Link>
                            <Link to="/casestudy">Deployments</Link>
                            <Link to="/team">Teams</Link>
                            <Link to="/contact">Contact</Link>
                        </div>
                    </div>

                    {/* Address */}
                    <p className="footer-address-mobile">
                        Roorkee, Uttarakhand <br />
                        support@parimitra.in
                    </p>

                    {/* Social Icons */}
                    <div className="footer-socials footer-socials-mobile">
                        <a href="https://in.linkedin.com/company/parimitra" target="_blank" rel="noopener noreferrer"><img src="/Images/Icons/linkedin.png" alt="" /></a>
                        <a href="https://www.youtube.com/@Parimitra" target="_blank" rel="noopener noreferrer"><img src="/Images/Icons/youtube.png" alt="" /></a> 
                    </div>

                    {/* Legal Links */}
                    <div className="footer-legal footer-legal-mobile">
                        <Link to="/privacy">Privacy Policy</Link>
                        <span>•</span>
                        <Link to="/terms">Terms of Service</Link>
                        <span>•</span>
                        {/* <Link to="/cookies">Cookie Policy</Link> */}
                    </div>

                    {/* Copyright */}
                    <p className="copyright copyright-mobile">
                        © 2026 Parimitra. All rights reserved.
                    </p>
                </>
            ) : (
                /* ======= DESKTOP VERSION ======= */
                <>
                    <div className="footer-content">

                        {/* Brand Column */}
                        <div className="footer-col brand-col">
                            <div className="footer-logo">
                                <img src="/Images/Icons/logo-green.svg" alt="PARIMITRA" className="brand-logo" />
                            </div>

                            <p className="brand-tagline">
                                Redefining Indian Roads with <br />
                                Smart Mobility Solutions.
                            </p>

                            <div className="footer-socials">
                                <a href="https://in.linkedin.com/company/parimitra" target="_blank" rel="noopener noreferrer"><svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />
                                </svg></a>

                                <a href="https://www.youtube.com/@parimitra" target="_blank" rel="noopener noreferrer"><svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M23.5 6.2a2.96 2.96 0 0 0-2.08-2.09C19.54 3.5 12 3.5 12 3.5s-7.54 0-9.42.61A2.96 2.96 0 0 0 .5 6.2 31.33 31.33 0 0 0 0 12a31.33 31.33 0 0 0 .5 5.8 2.96 2.96 0 0 0 2.08 2.09C4.46 20.5 12 20.5 12 20.5s7.54 0 9.42-.61a2.96 2.96 0 0 0 2.08-2.09A31.33 31.33 0 0 0 24 12a31.33 31.33 0 0 0-.5-5.8zM9.75 15.02V8.98L15.5 12l-5.75 3.02z"/>
                                </svg></a>
                                
                            </div>
                        </div>

                        {/* Solutions */}
                        <div className="footer-col">
                            <h3>Solutions</h3>
                            <ul className="footer-links-list">
                                <li><Link to="/products/trafficeye">Traffic Eye</Link></li>
                                <li><Link to="/products/transiteye">Transit Eye</Link></li>
                                <li><Link to="/products/crowdeye">Crowd Eye</Link></li>
                                <li><Link to="/products/video-analytics">Video Analytics</Link></li>
                            </ul>
                        </div>

                        {/* Company */}
                        <div className="footer-col">
                            <h3>Company</h3>
                            <ul className="footer-links-list">
                                <li><Link to="/about">About Us</Link></li>
                                <li><Link to="/gallery">Gallery</Link></li>
                                <li><Link to="/casestudy">Deployments</Link></li>
                                <li><Link to="/team">Teams</Link></li>
                                <li><Link to="/contact">Contact</Link></li>
                            </ul>
                        </div>

                        {/* Contact */}
                        <div className="footer-col contact-col">
                            <h3>Contact</h3>
                            <ul className="footer-contact-list">
                                <li>
                                    <span className="icon">📍</span>
                                    Roorkee, Uttarakhand
                                </li>
                                <li>
                                    <span className="icon">📞</span>
                                    +91 8147521822
                                </li>
                                <li>
                                    <span className="icon">✉️</span>
                                    support@parimitra.in
                                </li>
                            </ul>
                        </div>

                    </div>

                    {/* Desktop Bottom Bar */}
                    <div className="footer-bottom">
                        <p className="copyright">&copy; 2026 Parimitra. All rights reserved.</p>
                        <div className="footer-legal">
                            <Link to="/privacypolicy">Privacy Policy</Link>
                            <Link to="/termsofservice">Terms of Service</Link>
                            {/* <Link to="/cookies">Cookie Policy</Link> */}
                        </div>
                    </div>
                </>
            )
            }
        </footer >
    );
}
